import { Component, OnInit } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { ApiConfiguration } from "src/app/services/http/api-configuration";
import { ApiService } from "src/app/services/http/api.service";
import { XlsxService } from "src/app/services/xlsx/xlsx.service";
import { ExportExcelService } from "src/app/shared/xlsx-view/export-excel.service";
import { XlsxViewComponent } from "src/app/shared/xlsx-view/xlsx-view.component";

@Component({
  selector: "app-delete-achievement",
  templateUrl: "./delete-achievement.component.html",
  styleUrls: ["./delete-achievement.component.scss"],
})
export class DeleteAchievementComponent implements OnInit {
  filters: any = {
    target_id: "",
    reason: "",
    type: "",
    file: "",
  };
  targetList: any = [];
  deleteLogList: any = [];
  public headers;
  public columns;
  public save = true;
  public notice = true;
  public month;
  public year;
  public ro_name = [];
  public moduleId;
  public userList: any[];
  public excel = [
    {
      outlet_code: "",
    },
  ];
  importFile: boolean = false;
  editFile: boolean = false;
  file: any;
  fileName: string = "";
  excel_data: boolean = true;
  excelData: any[];
  page: number = 1;
  getPaginationCount: any;
  totalPages: any;

  constructor(
    private apiService: ApiService,
    private apiConfig: ApiConfiguration,
    private exportExcelService: ExportExcelService,
    private xls: XlsxService,
    private modalService: NgbModal,
    public ngxService: NgxUiLoaderService
  ) {}

  ngOnInit() {
    this.getTargetlist();
    this.getDeleteTargetLog();
  }
  getTargetlist() {
    this.apiService.get(this.apiConfig.deleteTargetsList).subscribe(
      (res: any) => {
        this.targetList = res.data;
        console.log(res);
      },
      (err: any) => {
        console.log(err);
      }
    );
  }
  getDeleteTargetLog() {
    this.apiService
      .getHeaders(this.apiConfig.getDeleteTargetLog + `?type=2`)
      .subscribe((res: any) => {
        this.deleteLogList = res.body.data;
        this.getPaginationCount = res.headers.get("X-Pagination-Total-Count");
        this.totalPages = res.headers.get("X-Pagination-Per-Page");
        console.log(res);
      });
  }
  paginationClick(page) {
    this.page = page;
    this.getDeleteTargetLog();
  }
  downloadTemplate() {
    let header = ["Mobile_Number"];
    let filename = "Delete_target_";
    this.exportExcelService.commonPrintHeaders(header, filename);
  }
  xlsxView(data) {
    let modalRef = this.modalService.open(XlsxViewComponent, {
      centered: true,
      backdrop: "static",
      size: "xl",
      scrollable: true,
      windowClass: "ExcelTemplateViewModal",
    });
    modalRef.componentInstance.xlsxDatas = data;
    modalRef.result.then(
      (result) => {
        let data = {
          outlets: [],
        };
        result.forEach((e) => {
          data.outlets.push(e);
        });
        this.apiService
          .post(this.apiConfig.importNewUsers, result)
          .subscribe((res: any) => {
            console.log(res);
          });
      },
      (reason) => {}
    );
  }

  importExcel(event) {
    this.editFile = true;
    this.importFile = false;
    if (event.target.files.length > 0) {
      this.fileName = event.target.files[0].name;
      this.file = event.target.files[0];
    }
    this.xls.uploadXlsx(event).then((res: any) => {
      this.headers = res.headers;
      this.columns = res.data;
      console.log(this.headers, this.columns);
      this.save = false;
      this.notice = false;
      this.excelData = res;
      console.log(this.excelData);
      this.editFile = false;
      if (this.columns.length != 0) {
        this.excel_data = false;
      }
    });
  }
  submitData() {
    this.ngxService.start();
    console.log(this.filters);
    let payload = {
      target_id: this.filters.target_id,
      reason: this.filters.reason,
      flag: this.filters.type,
      data: this.columns,
    };
    this.apiService.post(this.apiConfig.deleteAchievement, payload).subscribe(
      (res: any) => {
        this.filters = {
          target_id: "",
          reason: "",
          type: "",
          file: "",
        };
        console.log(res);
        this.getDeleteTargetLog()
        this.ngxService.stop();
      },
      (err: any) => {
        this.filters = {
          target_id: "",
          reason: "",
          type: "",
          file: "",
        };
        this.ngxService.stop();
      }
    );
  }
  isFormValid(): boolean {
    if (!this.filters.target_id || !this.filters.reason || !this.filters.type) {
      return false; // Basic required fields missing
    }

    if (this.filters.type == 2 && !this.filters.file) {
      return false; // File is required for type 2
    }

    return true;
  }
  type: any;
  responseData: any = [];
  detailedData(modalRef: any, data: any, type: any) {
    this.type = type;
    this.responseData = data;
    this.modalService.open(modalRef, { centered: true });
  }
}
